export const GET_ALL_CUSTOM_FIELDS = 'getAllCustomFields';
export const GET_CUSTOMFIELD_ALL_CONTEXTS = 'getCustomFieldAllContexts';
export const GET_CUSTOMFIELD_ALL_CONTEXTS_PAGINATED = 'getCustomFieldAllContextsPaginated';
export const GET_CUSTOMFIELD_CONTEXT_WITH_DEFAULT_OPTION = 'getCustomFieldAllContextWithDefaultOption';
export const GET_CUSTOMFIELD_CONTEXT_ALL_OPTIONS = 'getCustomFieldContextAllOptions';
export const GET_CUSTOMFIELD_EDITOR_CONTEXT = 'getCustomfieldEditorContextV3';
export const CREATE_CUSTOMFIELD_OPTION = 'createCustomfieldOption';
export const DELETE_CUSTOMFIELD_OPTION = 'deleteCustomfieldOption';
export const SET_CUSTOMFIELD_DEFAULT_OPTION = 'setCustomfieldDefaultOption';
export const GET_SINGLE_CUSTOMFIELD_OPTION = 'getSingleCustomfieldOption';
export const UPDATE_CUSTOMFIELD_OPTION = 'updateCustomfieldOption';
export const MOVE_CUSTOMFIELD_OPTION = 'moveCustomfieldOption';
export const SET_CUSTOMFIELD_PERMISSIONS = 'setCustomfieldPermissions';
export const PATCH_USER_PERMISSIONS = 'patchUserPermissions';
export const PATCH_GROUP_PERMISSIONS = 'patchGroupPermissions';
export const GET_CUSTOMFIELD_PERMISSIONS_PAGINATED_GROUPS = 'getCustomfieldPermissionsGroups';
export const GET_CUSTOMFIELD_PERMISSIONS_PAGINATED_USERS = 'getCustomfieldPermissionsUsers';
export const GET_CUSTOMFIELD_PERMISSIONS_ALL_GROUPIDS_USERIDS = 'getCustomfieldPermissionsIdsOnly';
export const GET_USER_PICKER_QUERY = 'getUserPickerQuery';
export const GET_GROUP_PICKER_QUERY = 'getGroupPickerQuery';
